export interface CreatePasswordResponse {
  success: boolean;
  error: number | null;
  forward: string | null;
}

export const createPassword = async (
  newPassword: string,
  confirmNewPassword: string,
  token: string,
  forward: string | null,
): Promise<CreatePasswordResponse> => {
  try {
    const response = await fetch(`/password/create/${token}`, {
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      },
      redirect: 'follow',
      referrerPolicy: 'strict-origin-when-cross-origin',
      body: JSON.stringify({
        Password: newPassword,
        ConfirmPassword: confirmNewPassword,
        Forward: forward,
        Token: token,
      }),
    });

    if (!response.ok) {
      return handleUnexpectedError(forward);
    }

    const result = await response.json();

    return {
      success: !!result?.success,
      error: result?.error,
      forward: result?.forward,
    };
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);

    return handleUnexpectedError(forward);
  }
};

const handleUnexpectedError = (forward: string | null): CreatePasswordResponse => ({
  success: false,
  error: null,
  forward,
});
